import React, { Component } from 'react';

// Externals
import compose from 'recompose/compose';

// Material helpers
import { withRouter } from 'react-router-dom';

// Shared components
import 'react-perfcascade/dist/react-perfcascade.css';
// Material components
import Typography from '@material-ui/core/Typography';
import {HarFileView} from 'react-perfcascade';
import styles from './styles';
import { withStyles } from '@material-ui/core/styles';
import {getElements} from '../../../../../services/getElements'
import {getHar} from '../../../../../utils/getHar'
import PieStatistics from '../PieStatistics'
import Button from '@material-ui/core/Button';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import CloudDownload from '@material-ui/icons/CloudDownload'
import Tooltip from '@material-ui/core/Tooltip';
import { CSVLink } from "react-csv";
// Component styles
import { Box, Card, CardContent, CardHeader, Dialog, DialogContent, DialogTitle, ExpansionPanelSummary, Grid, Table, TableCell, TableRow } from '@material-ui/core';
import moment from 'moment'
import 'moment/locale/es'
import { AtCircularProgress } from '../../../../../components/AtCircularProgress';
import { withTranslation } from 'react-i18next';
moment.locale('es')

class ElementsPlus extends Component {
    constructor(props) {
        super(props);
        var name=""
        var nameNode=""
        if(typeof(props.overview)==="undefined"){
            name=props.match.params.nombre_objetivo
            nameNode=props.node.titulo
        }else{
            name=props.params.props.objName
            nameNode=props.dataNode.titulo
        }
        this.state = {
            nameObj:name,
            isLoad:true,
            perf:null,
            objective:this.props.objective,
            steps:this.props.steps,
            date:this.props.date,
            node:this.props.node,
            nameNode:nameNode,
            div:<div></div>,
            open: false,
            display:"none",
            divElements:<div></div>,
            openElements: false,
            displayElements:"none",
            data:[],
            selectedStep: '',
        };
    }

    componentDidMount() {
        this.processData();
    }

    getFetchs = (objective, steps, date, token, user, monitor) =>{
        //console.log(objective, date, token, user,monitor)
        return new Promise((resolve, reject) => {
            var List = []
            var fetches = []
            steps.forEach((step, key)=>{
                //console.log(key)
                var getData=getElements(objective, monitor, step.id_paso, token, user, date)
                fetches.push(                    
                    getData.then( data =>  { 
                        data["nombre_paso"]=step.nombre_paso
                        List[step.id_paso] = data
                    })                    
                )
            })
            Promise.all(fetches).then(() => {
                resolve(List);
            })      
        });
    }

   
    processData = () => {
        const { objective, steps, date, node}=this.state
        let token = sessionStorage.getItem('key')
        let id_user = sessionStorage.getItem('user')
        var data =this.getFetchs(objective, steps, date.fecha, token, id_user, node.monitor)
        data.then( value=>{
            value.map(step=>{
                if(Object.keys(step).length>3){
                    //console.log('nombre paso', step.nombre_paso)
                    
                    //console.log('ele', step.elementos)
                    var sumatoria=0
                    var descarga=0
                    var eleCount=0
                    var eleOK=0
                    var eleError=0
                    var types_counter = {};
                    var listOK=[]
                    var listError=[]
                    var listExclusion=[]
                    var listRedireccion=[]
                    if(step.elementos.length!==0){
                        step.elementos.map(ele=>{
                            var estado=parseInt(ele.params.estado)
                            if(estado>=200 && estado<300){
                                listOK.push(ele.params)
                            }else if(estado>=300 && estado<400){
                                listRedireccion.push(ele.params)
                            }else if(estado>=400 && estado<1000){
                                listError.push(ele.params)
                            }else if(estado===1000 || estado===1007){
                                listExclusion.push(ele.params)
                            }else{
                                listError.push(ele.params)
                            }
    
                            if (!types_counter.hasOwnProperty(ele.params.tipo)) {
                                types_counter[ele.params.tipo] = 0
                            }
                            types_counter[ele.params.tipo] += 1;
                            var estadoCode=parseInt(ele.params.estado)
                            if(estadoCode===0 || estadoCode>=200 && estadoCode<300 ){
                                eleOK=eleOK+1
                            }else{
                                eleError=eleError+1
                            }
                            sumatoria=sumatoria + parseFloat(ele.params.duracion)
                            if(parseFloat(ele.params.cabecera)!==-1){
                                descarga=descarga + (parseFloat(ele.params.cuerpo)+parseFloat(ele.params.cabecera)) 
                            }else{
                                descarga=descarga + (parseFloat(ele.params.cuerpo))
                            }
                            eleCount=eleCount+1
    
                        })
                        step["listItems"]={"ok":listOK, "error":listError, "exclusion":listExclusion, "redireccion":listRedireccion}
                        step["contador_tipos"]=types_counter
                        step["totalOK"]=parseFloat(eleOK.toFixed(2))
                        step["totalError"]=parseFloat(eleError.toFixed(2))
                        step["eleTotal"]=eleCount
                        step["sumatoria"]=parseFloat(sumatoria.toFixed(2))
                        step["tamanoTotal"]=parseFloat((descarga/1024).toFixed(2))
                        //console.log(step)
                        step["har"]=getHar(step, date, [])
                        //console.log(step.har)
                    }
                    
                }
                
            })
            //console.log('hard', harData)
            //console.log(value)
            this.setState({
                isLoad:false,
                steps:value,
            })
        })
        
    }
    handleClose = event => {
        //const newStep = event.currentTarget.id
        this.setState({
            open: false,
            display:"none"
            //objmodal: newStep
        })
    };

    handleCloseElements = event => {
        //const newStep = event.currentTarget.id
        this.setState({
            openElements: false,
            displayElements:"none"
            //objmodal: newStep
        })
    };
    getStatistics(e, step){
        const {steps}=this.state
        //console.log(steps[e])
        //console.log('fsd', e, step.currentTarget.value )
        var data=e+""+step.currentTarget.value
        //console.log('fssdad', e.currentTarget.id, )
        //console.log('fasdfawdsd', e.target)
        //console.log('sfda', e.target.value)
        this.setState({
            display:"inline",
            open: true,
            //div:<div style={{color:"white"}}>{data}</div>,
            div:<PieStatistics data={steps[e]} />
        })
    }

    getElements(step, date, e){
        const t = (this.props && this.props.t) ? this.props.t : (s => s);
        if(typeof(step.currentTarget)!=="undefined" && step.currentTarget.id==="csv"){
            var entries=(date.elementos)
            var dataCsv=[]
            entries.map((ele, i)=>{
                var params=ele.params
                var url=params.urlComplete
                var splitUrl=url.split("/")
                var descripcion="ok"
                var esOk="si"
                if(params.estado!=="200"){
                    descripcion=""
                    esOk="no"
                }
                var dict = {id:i,url:url, nombre_corto:splitUrl[splitUrl.length-1], ip:params.ip, "tiempo total descarga (s)":parseFloat(params.duracion)*1000, 
                    "latencia (s)":parseFloat(params.latencia)/1000, "descarga (s)":params.descarga, "tamaño body (bytes)":params.cuerpo, 
                    tipo:params.tipo, codigo_estado:params.estado, es_ok:esOk, descripcion_estado:descripcion}
                dataCsv.push(dict)
            })
            this.setState({
                displayElements:"hidden",
                openElements: false,
                divElements:"",
                data:dataCsv
            })
        }else{
            var grid= <Box>
                {step.har ?
                <Box id={date.fecha+step.nombre_paso}>
                    <Box item id={date+step.nombre_paso} style={{marginBottom: 10, display: 'flex', justifyContent: 'end'}}>
                        <Button title={step.paso_orden} value={date} onClick={this.getStatistics.bind(this,step.paso_orden )} variant='outlined' color='primary'>
                            {t('elements-plus.button.statistics')}
                        </Button>
                    </Box>
                    <Box style={{overflowY: 'auto', maxHeight: 500, overflowX: 'auto'}}>
                        {this.har(step)}
                    </Box>
                    <Box>
                        <Table size='small' className='at-custom-form-table'>
                            <TableRow>
                                <TableCell><Typography variant="caption">{t('elements-plus.table.cell.download-time')}</Typography></TableCell>
                                <TableCell align='right'><Typography variant="caption">{step.totalTime}</Typography></TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell><Typography variant="caption">{t('elements-plus.table.cell.sum-time')}</Typography></TableCell>
                                <TableCell align='right'><Typography variant="caption">{step.sumatoria}</Typography></TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell><Typography variant="caption">{t('elements-plus.table.cell.total-size')}</Typography></TableCell>
                                <TableCell align='right'><Typography variant="caption">{step.tamanoTotal}</Typography></TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell><Typography variant="caption">{t('elements-plus.table.cell.total-elements')}</Typography></TableCell>
                                <TableCell align='right'><Typography variant="caption">{step.eleTotal}</Typography></TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell><Typography variant="caption">{t('elements-plus.table.cell.total-elements-ok')}</Typography></TableCell>
                                <TableCell align='right'><Typography variant="caption">{step.totalOK}</Typography></TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell><Typography variant="caption">{t('elements-plus.table.cell.total-elements-error')}</Typography></TableCell>
                                <TableCell align='right'><Typography variant="caption">{step.totalError}</Typography></TableCell>
                            </TableRow>
                        </Table>
                    </Box>
                </Box>
                :<Box id={date+step.nombre_paso}>
                        <Typography >{t('elements-plus.no-information')}</Typography>
                </Box>
                }
            </Box>
            
            this.setState({
                displayElements:"inline",
                openElements: true,
                divElements:grid,
                selectedStep: step?.nombre_paso ?? '',
            })
        }
        
    }

    har=(step)=>{
        var newHar=<div>sin datos</div>
        if(Object.keys(step).length>4){
            newHar=<HarFileView /*harData={harData2}*/ harData={step.har}/>
        }  
        return newHar
    }

    createHar=(date, steps)=>{
        const t = (this.props && this.props.t) ? this.props.t : (s => s);
        const {classes}=this.props
        const {data, nameObj, nameNode}=this.state

        var Har=
            
            steps.map(step=>(
                <ExpansionPanelSummary style={{backgroundColor: '#142452'}}>
                    <Box display='flex' flexDirection='row'>
                        <Box>
                            <Button onClick={this.getElements.bind(this,step, date.fecha)} ><Typography className={classes.textWhite}>{t('elements-plus.detail-elements-step')} <b>{step.nombre_paso}</b></Typography></Button>
                        </Box>
                        {step.har?
                        <Box display='flex' alignItems='center'>
                            <Tooltip title={t('elements-plus.download-csv')} placement="top">
                                <CSVLink id="csv" data={data} filename={nameObj+"_"+nameNode+"_"+date.fecha+"_"+step.nombre_paso+".csv"}                                    
                                    asyncOnClick={true}
                                    onClick={(event) => {
                                        this.getElements(event, step, date.fecha)
                                    }}>
                                        <CloudDownload className={classes.openCsvIcon} />
                                </CSVLink>
                                
                            </Tooltip>
                        </Box>
                        :<Box style={{textAlign:"center"}} className={classes.padding0}>
                            <Typography variant="h6" style={{color:"white"}}>{t('elements-plus.no-elements')}</Typography>
                        </Box>}
                    </Box>
                </ExpansionPanelSummary>
            ))
        return Har
    }
    render() {

        const { isLoad, steps, date, open, div,openElements, divElements, nameNode, nameObj, selectedStep} = this.state;
        const t = (this.props && this.props.t) ? this.props.t : (s => s);
        if (isLoad===true) {
            return(
                <AtCircularProgress />
            )
        }else{
            return(
                <div>
                    {/*MODAL ELEMENTOS PLUS*/}
                <Dialog
                    maxWidth="lg"
                    fullWidth
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={openElements}
                    onClose={this.handleCloseElements}
                    closeAfterTransition
                    disableAutoFocus={true}
                    disableEnforceFocus={true}
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                        timeout: 500,
                    }}
                    >                                    
                        <Fade in={openElements}>
                            <>
                                <DialogTitle>
                                    <Typography variant='h4' className='card__text--dark-color'>{nameObj} - {nameNode} - {selectedStep}</Typography>
                                </DialogTitle>
                                <DialogContent>
                                    {divElements}
                                </DialogContent>
                            </>
                        </Fade>
                </Dialog>
                {/*MODAL ELEMENTOS PLUS*/}
                <Dialog
                    fullWidth
                    maxWidth='md'
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={open}
                    onClose={this.handleClose}
                    closeAfterTransition
                    disableAutoFocus={true}
                    disableEnforceFocus={true}
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                        timeout: 500,
                    }}
                    >                                    
                        <Fade in={open}>
                            <>
                                <DialogTitle className='at-blue-background'>
                                    <Typography variant='h4'>{t('elements-plus.button.statistics')}</Typography>
                                </DialogTitle>
                                <DialogContent>
                                    {div}
                                </DialogContent>
                            </>
                        </Fade>
                </Dialog>
                {this.createHar(date, steps)}
                </div>
            )
        }
        
        
    }
}



export default compose(withRouter, withStyles(styles), withTranslation())(ElementsPlus);